module.exports = __webpack_public_path__ + "static/media/MHRP09N0025.044a531d.svg";